import { connect } from 'react-redux';
import { FetchCalendarEvents } from '../actions';
import Calendar from './Calendar';

const mapStateToProps = (state) => {
	return {
		events: state.job.calendarEvents,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchCalendarEvents: (timeMin, timeMax) => dispatch(FetchCalendarEvents(timeMin, timeMax)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
